import { render, staticRenderFns } from "./PeopleCount.vue?vue&type=template&id=7f6aaf1e&"
import script from "./PeopleCount.vue?vue&type=script&lang=js&"
export * from "./PeopleCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports